import i18n from 'i18next';

export const validate = (values) => {
  const errors = {};

  if (!values.agreement) {
    errors.agreement = i18n.t('validation_error_agreement_required');
  }

  if (!values.name) {
    errors.name = i18n.t('validation_error_name_required');
  }

  if (!values.phone || values.phone.includes('_') || values.phone.length < 7) {
    errors.phone = i18n.t('validation_error_phone_required');
  }

  return errors;
};